module.exports = __webpack_public_path__ + "static/img/bugimg4.b494050.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bugimg4.png
// module id = QvUb
// module chunks = 1